import { render, staticRenderFns } from "./Press.vue?vue&type=template&id=0b009e57&scoped=true"
import script from "./Press.vue?vue&type=script&lang=js"
export * from "./Press.vue?vue&type=script&lang=js"
import style0 from "./Press.vue?vue&type=style&index=0&id=0b009e57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b009e57",
  null
  
)

export default component.exports